import { useCycleTimer, CyclePhase } from '../../hooks/useCycleTimer';
import { Button } from '../UI/Button';
import styles from './CycleTimer.module.css';

interface CycleTimerProps {
  onCycleStart?: () => void;
  onCycleEnd?: () => void;
}

const PHASE_LABELS: Record<CyclePhase, string> = {
  refinement: 'Refinement',
  doing: 'Doing',
  wrapup: 'Wrap Up',
};

export function CycleTimer({ onCycleStart, onCycleEnd }: CycleTimerProps) {
  const { isCycleActive, cycleTimeRemaining, currentPhase, startCycle, cancelCycle } = useCycleTimer();

  const formatTime = (milliseconds: number): string => {
    const totalSeconds = Math.floor(milliseconds / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  };

  const handleStart = () => {
    startCycle();
    onCycleStart?.();
  };

  const handleCancel = () => {
    cancelCycle();
    onCycleEnd?.();
  };

  if (!isCycleActive) {
    return (
      <div className={styles.cycleSection}>
        <Button
          variant="primary"
          onClick={handleStart}
          className={styles.startButton}
        >
          Start Cycle
        </Button>
      </div>
    );
  }

  return (
    <div className={styles.cycleSection}>
      <div className={styles.cycleTimer}>
        <div className={styles.countdown}>
          {formatTime(cycleTimeRemaining)}
        </div>
        
        {currentPhase && (
          <div className={`${styles.phaseBanner} ${styles[currentPhase]}`}>
            {PHASE_LABELS[currentPhase]}
          </div>
        )}

        <div className={styles.cycleActions}>
          <Button
            variant="default"
            onClick={handleCancel}
          >
            Cancel Cycle
          </Button>
        </div>
      </div>
    </div>
  );
}
